import { render, staticRenderFns } from "./supplierbalances.vue?vue&type=template&id=11917158&"
import script from "./supplierbalances.vue?vue&type=script&lang=js&"
export * from "./supplierbalances.vue?vue&type=script&lang=js&"
import style0 from "./supplierbalances.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports